<template>
<div>
    <matter-form ref="lawMatterForm"></matter-form>
    <invoice-form :invoiceFormPropsFunctions="invoiceFormPropsFunctions" :getDailyworkReportList="getDailyworkReportList" ref="invoiceForm"></invoice-form>
    <dailywork-form :getDailyworkReportList="getDailyworkReportList" ref="dailyworkForm"></dailywork-form>
    <div class="custom-search">
        <!-- Word dizilimi: 6 sutun + buton sutunu; butonlar 2. satirin kutulariyla ayni hizada -->
        <div class="dw-filter-grid">
            <div class="dw-filter">
                <label>{{ $t('dailyworkReport.agent') }}</label>
                <v-select id="agent" v-model="agentSelect" :options="agentOption" @input="setClientId" label="clientName" @search="onSearch"></v-select>
            </div>
            <div class="dw-filter">
                <label>{{ $t('dailyworkReport.ownerClient') }}</label>
                <b-form-input size="sm" v-model="ownerClient" :placeholder="$t('dailyworkReport.ownerClient')" type="text" class="d-inline-block" />
            </div>
            <div class="dw-filter">
                <label>{{ $t('dailyworkReport.shortName') }}</label>
                <b-form-input size="sm" v-model="shortName" :placeholder="$t('dailyworkReport.shortName')" type="text" class="d-inline-block" />
            </div>
            <div class="dw-filter">
                <label>{{ $t('dailyworkReport.description') }}</label>
                <b-form-input size="sm" v-model="description" :placeholder="$t('dailyworkReport.description')" type="text" class="d-inline-block" />
            </div>
            <div class="dw-filter">
                <label>{{ $t('dailyworkReport.employee') }}</label>
                <b-form-select v-model="employeeSelect" size="sm" value-field="id" text-field="name" :options="employeeOption" />
            </div>
            <div class="dw-filter">
                <label>{{ $t('dailyworkReport.firstLawyer') }}</label>
                <b-form-select v-model="firstLawyerSelect" size="sm" value-field="id" text-field="name" :options="firstLawyerOption" />
            </div>
            <div class="dw-filter dw-filter-row2-start">
                <label>{{ $t('dailyworkReport.recordNo') }}</label>
                <b-form-input size="sm" v-model="recordNo" :placeholder="$t('dailyworkReport.recordNo')" type="text" class="d-inline-block" />
            </div>
            <div class="dw-filter">
                <label for="dailywork-report-start-date-input"> {{ $t('dailyworkReport.recordDateStart') }} </label>
                <b-form-datepicker id="dailywork-report-start-date-input" today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('dailyworkReport.recordDateStart')" size="sm" v-model="recordDateStart" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </div>
            <div class="dw-filter">
                <label for="dailywork-report-end-date-input"> {{ $t('dailyworkReport.recordDateEnd') }} </label>
                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('dailyworkReport.recordDateEnd')" size="sm" v-model="recordDateEnd" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </div>
            <div class="dw-filter">
                <label>{{ $t('dailyworkReport.billingStatus') }}</label>
                <b-form-select v-model="lawBillingStatusSelect" size="sm" value-field="id" text-field="name" :options="lawBillingStatusOption" />
            </div>
            <div class="dw-filter">
                <label>{{ $t('dailyworkReport.recordType') }}</label>
                <b-form-select v-model="recordTypeSelect" size="sm" value-field="id" text-field="name" :options="recordTypeOption" />
            </div>
            <div class="dw-filter-actions">
                <b-button class="mr-1" size="sm" v-on:keyup.enter="reloadFromFirstPage()" variant="outline-primary" @click="reloadFromFirstPage()">{{$t('dailyworkReport.list')}}</b-button>
                <b-button class="mr-1" style="border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="exportExcel()">{{ $t('others.excel') }}</b-button>
                <b-button variant="outline-primary" size="sm" class="dw-invoice-btn" :class="{ 'dw-invoice-btn-active': selectedRows.length > 0 }" :disabled="selectedRows.length === 0" @click.prevent="showInvoiceForm()">
                    {{ $t('dailywork.invoice') }}<template v-if="selectedRows.length > 0"> ({{ selectedRows.length }})</template>
                </b-button>
            </div>
        </div>
    </div>
    <br />
    <!-- table -->
    <div class="dw-table-wrap">
    <!-- Sitedeki toast kartinin gorunumu; konum, ikon ve sure Word'e gore.
         Kapsayicinin ust kenarina gore konumlanir: secim varken secim cubugunun, yokken tablonun ustu -->
    <div v-if="agentToast.show" class="dw-agent-toast" role="alert">
        <span class="dw-agent-toast-icon">!</span>
        <h5 class="mb-0 font-weight-bolder dw-agent-toast-title">{{ agentToast.text }}</h5>
        <span class="cursor-pointer dw-agent-toast-close" role="button" :aria-label="$t('dailyworkReport.close')" @click="hideAgentToast()">
            <feather-icon icon="XIcon" class="text-body" />
        </span>
    </div>
    <!-- Secim ozet cubugu: farkli para birimleri toplanmaz -->
    <div v-if="selectedRows.length > 0" class="dw-selection-bar">
        <div>
            <b>{{ selectedAgent.name }}</b>
            · {{ $t('dailyworkReport.recordCount', { count: selectedRows.length }) }}
            <template v-for="total in selectedTotals"> · {{ total.currency }} {{ $formatMoneyTr(total.amount) }}</template>
        </div>
        <a class="dw-selection-clear" role="button" @click="clearSelection()">{{ $t('dailyworkReport.clearSelection') }}</a>
    </div>
    <vue-good-table id="dailyworkReportTable" ref="dailyworkReportTable" :columns="columns" :rows="rows" mode="remote" :total-rows="total" @on-sort-change="onSortChange" :sort-options="{
            enabled: true,
            initialSortBy: { field: 'recordDate', type: 'desc' }
          }" styleClass="vgt-table condensed tableSize" :search-options="{
            enabled: true,
            externalQuery: searchTerm}" :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }" :pagination-options="{
              enabled: true,
              perPage: pageLength
            }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'isSelected'" :class="{ 'dw-cb-disabled': isCheckboxDisabled(props.row) }" :title="checkboxTitle(props.row)" @click="onCheckboxWrapClick(props.row)">
                <b-form-checkbox :checked="!!props.row.isSelected" :disabled="isCheckboxDisabled(props.row)" @change.native="changeChecked(props.row.id, $event.target)" text-field="name" class="demo-inline-spacing" />
            </span>
            <span v-else-if="props.column.field === 'invoiceClientAccounting'" class="d-block">
                <span class="wh-clamp-2 dw-agent-name" v-b-tooltip.hover="{ title: props.row.invoiceClient, customClass: 'wh-tooltip' }">{{ props.row.invoiceClient }}</span>
                <span class="d-block dw-agent-no">{{ props.row.invoiceClientAccountingNo }}</span>
            </span>
            <span v-else-if="props.column.field === 'price'">
                <span>
                    {{ $formatMoneyTr(props.row.price) }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'ownerClient'" v-b-tooltip.hover="{ title: props.row.ownerClient, customClass: 'wh-tooltip' }" class="wh-clamp-2">
                {{ props.row.ownerClient }}
            </span>
            <span v-else-if="props.column.field === 'shortName'" v-b-tooltip.hover="{ title: props.row.shortName, customClass: 'wh-tooltip' }" class="wh-clamp-2">
                {{ props.row.shortName }}
            </span>
            <span v-else-if="props.column.field === 'description'" v-b-tooltip.hover="{ title: props.row.description, customClass: 'wh-tooltip' }" class="wh-clamp-2">
                {{ props.row.description }}
            </span>
            <span v-else-if="props.column.field === 'lawMatterRecordNo'" class="text-nowrap">
                <b-badge variant="primary" style="cursor: pointer;" @click="showLawMatterForm(props.row)">
                    <feather-icon icon="MousePointerIcon" class="mr-25" />
                </b-badge>
                <span>{{ props.row.lawMatterRecordNo }}</span>
            </span>
            <span v-else-if="props.column.field === 'lawBillingStatus'" style="cursor:pointer" :title="props.row.lawBillingStatus">
                <span v-if="billingStatusRing(props.row)" class="dw-ring" :class="billingStatusRing(props.row)" />
            </span>
            <span v-else-if="props.column.field === 'employee'" class="text-nowrap" v-b-tooltip.hover="{ title: props.row.employee, customClass: 'wh-tooltip' }">{{ shortEmployeeName(props.row.employee) }}</span>
            <span v-else-if="props.column.field === 'lawServiceType'">
                <span v-if="props.row.lawServiceType" class="dw-record-type">{{ recordTypeText(props.row.lawServiceType) }}</span>
            </span>
            <span v-else-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => openDailyworkForm(props.row) },
                    { icon: 'ArchiveIcon', label: $t('others.archive'), color: '#DC2626', show: !isArchiveButonHidden(props.row), handler: () => archiveRecord(props.row) }
                ]" />
            </span>
        </template>

        <!-- Para birimi ozeti: tablonun altinda, yatay kaydirma alaninin disinda (vgt table-actions-bottom).
             Filtre sonucunun tamami; Do Not Invoice haric; farkli para birimleri toplanmaz -->
        <div slot="table-actions-bottom">
            <table v-if="currencyTotals.length > 0" class="dw-currency-summary">
                <thead>
                    <tr>
                        <th>{{ $t('dailyworkReport.currencyCode') }}</th>
                        <th class="text-right">{{ $t('dailyworkReport.summaryCount') }}</th>
                        <th class="text-right">{{ $t('dailyworkReport.summaryTotal') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="t in currencyTotals" :key="t.currency">
                        <td>{{ t.currency }}</td>
                        <td class="text-right">{{ t.count }}</td>
                        <td class="text-right">{{ $formatMoneyTr(t.amount) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <!-- Sitedeki standart alt bilgi -->
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}
                    </span>
                    <b-form-select v-model="pageLength" :options="pageLengthOptions" class="mx-1" @change="onPageLengthChange()" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getDailyworkReportList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            id: 0,
            employeeOption: [],
            employeeSelect: 0,
            lawBillingStatusOption: [],
            lawBillingStatusSelect: 0,
            firstLawyerOption: [],
            firstLawyerSelect: 0,
            recordTypeSelect: 0,
            agentSelect: 0,
            agentOption: [],
            recordNo: '',
            clientAccountingId: 0,
            invoiceFormPropsFunctions: 1,
            recordDateStart: null,
            recordDateEnd: null,
            ownerClient: '',
            description: '',
            shortName: '',
            columns: [{
                    label: '',
                    field: `isSelected`,
                    sortable: false,
                },
                {
                    label: this.$t('dailyworkReport.recordNo'),
                    field: `lawMatterRecordNo`,
                },
                {
                    label: this.$t('dailyworkReport.invoiceAgent'),
                    field: `invoiceClientAccounting`,
                    tdClass: 'dw-agent-cell',
                },
                {
                    label: this.$t('dailyworkReport.ownerClient'),
                    field: `ownerClient`,
                    tdClass: 'dw-owner-cell',
                },
                {
                    label: this.$t('dailyworkReport.shortName'),
                    field: `shortName`,
                    tdClass: 'dw-short-name-cell',
                },
                {
                    label: this.$t('dailyworkReport.description'),
                    field: `description`,
                    tdClass: 'dw-description-cell',
                },
                {
                    label: this.$t('dailyworkReport.recordDate'),
                    field: `recordDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('dailyworkReport.amount'),
                    field: `price`,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
                {
                    label: this.$t('dailyworkReport.currencyCode'),
                    field: `currency`,
                },
                {
                    label: this.$t('dailyworkReport.employee'),
                    field: `employee`,
                },
                {
                    label: this.$t('dailyworkReport.billingStatus'),
                    field: `lawBillingStatus`,
                    sortable: false,
                },
                {
                    label: this.$t('dailyworkReport.recordType'),
                    field: `lawServiceType`,
                },
                {
                    label: '',
                    field: 'process',
                    width: '5em',
                    sortable: false
                },
            ],
            rows: [],
            total: 0,
            pageLength: 50,
            pageLengthOptions: [10, 25, 50, 100],
            sortField: 'recordDate',
            sortDirection: 'desc',
            pageNo: 1,
            dir: false,
            searchTerm: '',
            searchDebounce: null,
            requestSeq: 0,
            currencyTotals: [],
            agentToast: { show: false, text: '' },
            agentToastTimer: null
        }
    },
    computed: {
        // LawServiceType id'leri: 3 = T (Hizmet), 2 = E (Masraf); 1 = A pasif
        recordTypeOption() {
            return [
                this.$nullSelected(),
                { id: 3, name: this.recordTypeText('T') },
                { id: 2, name: this.recordTypeText('E') }
            ]
        },
        // Faturaya yalnizca ayni fatura ajaninin (ClientAccounting) kayitlari eklenebilir
        selectedRows() {
            return this.rows.filter(p => p.isSelected === true)
        },
        selectedAgent() {
            const selected = this.selectedRows[0]
            return selected ? { id: selected.invoiceClientAccountingId, name: selected.invoiceClient } : null
        },
        // Para birimi basina toplam, para birimleri alfabetik
        selectedTotals() {
            const totals = {}
            this.selectedRows.forEach(p => {
                totals[p.currency] = (totals[p.currency] || 0) + p.price
            })
            return Object.keys(totals).sort().map(currency => ({ currency, amount: totals[currency] }))
        }
    },
    beforeDestroy() {
        clearTimeout(this.agentToastTimer)
    },
    watch: {
        recordDateStart(newValue) {
            if (newValue == '') {
                this.recordDateStart = null
            }
        },
        recordDateEnd(newValue) {
            if (newValue == '') {
                this.recordDateEnd = null
            }
        },
        ownerClient() {
            this.debouncedSearch()
        },
        shortName() {
            this.debouncedSearch()
        },
        description() {
            this.debouncedSearch()
        },
        recordNo() {
            this.debouncedSearch()
        }
    },
    mounted() {
        const controller = {
            name: 'LawDailywork',
            actionName: 'GetLawDailyworkReportInfo'
        }
        const payload = {
            controller: controller
        }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
            if (response.data.resultStatus == true) {
                this.employeeOption = response.data.employeeList
                this.lawBillingStatusSelect = 0
                this.lawBillingStatusOption = response.data.lawBillingStatusList
                this.firstLawyerOption = response.data.firstLawyerList || []
                this.firstLawyerOption.splice(0, 0, this.$nullSelected())
                this.employeeOption.splice(0, 0, this.$nullSelected())
                this.lawBillingStatusOption.splice(0, 0, this.$nullSelected())
                this.employeeSelect = localStorage.getItem('EmployeeId')
                this.getDailyworkReportList()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        })
    },
    methods: {
        debouncedSearch() {
            clearTimeout(this.searchDebounce)
            this.searchDebounce = setTimeout(() => {
                this.reloadFromFirstPage()
            }, 300)
        },
        // pageNo degisince b-pagination @input ile listeyi zaten yukler; ikinci istek gitmesin
        reloadFromFirstPage() {
            if (this.pageNo != 1) {
                this.pageNo = 1
            } else {
                this.getDailyworkReportList()
            }
        },
        // Siralama sunucuda yapilir (remote mod); yeni siralamada ilk sayfaya donulur
        onSortChange(params) {
            const sort = params && params[0]
            const hasSort = sort && sort.field && sort.type !== 'none'
            const sortField = hasSort ? sort.field : 'recordDate'
            const sortDirection = hasSort ? sort.type : 'desc'
            // vue-good-table yuklenirken initialSortBy icin de bu olayi tetikler; degisiklik yoksa istek atilmaz
            if (sortField === this.sortField && sortDirection === this.sortDirection) return
            this.sortField = sortField
            this.sortDirection = sortDirection
            this.reloadFromFirstPage()
        },
        onPageLengthChange() {
            this.reloadFromFirstPage()
        },
        clearSelection() {
            this.rows = this.rows.map(p => ({ ...p, isSelected: false }))
        },
        isAgentLocked(row) {
            return !!this.selectedAgent && row.invoiceClientAccountingId != this.selectedAgent.id
        },
        isCheckboxDisabled(row) {
            return this.isDoNotInvoice(row) || this.isAgentLocked(row)
        },
        checkboxTitle(row) {
            if (this.isDoNotInvoice(row)) return this.$t('dailyworkReport.doNotInvoiceTitle')
            if (this.isAgentLocked(row)) return this.$t('dailyworkReport.differentAgentTitle')
            return null
        },
        onCheckboxWrapClick(row) {
            if (!this.isDoNotInvoice(row) && this.isAgentLocked(row)) this.showAgentToast()
        },
        showAgentToast() {
            this.agentToast = { show: true, text: this.$t('dailyworkReport.differentAgentToast', { agent: this.selectedAgent.name }) }
            clearTimeout(this.agentToastTimer)
            this.agentToastTimer = setTimeout(() => this.hideAgentToast(), 5000)
        },
        hideAgentToast() {
            clearTimeout(this.agentToastTimer)
            this.agentToast.show = false
        },
        isDoNotInvoice(row) {
            // LawBillingStatus: 1 Invoice&Accounting, 2 Do Not Invoice, 3 Do Not Sent Accounting
            return row.lawBillingStatusId == 2
        },
        billingStatusRing(row) {
            const map = { 1: 'dw-ring-green', 2: 'dw-ring-yellow', 3: 'dw-ring-red' }
            return map[row.lawBillingStatusId]
        },
        // Ilk kelime ad, kalan kelimelerin bas harfleri: "Aysel Karaca" -> "Aysel K.", "Gizem Kukuk Demir" -> "Gizem K.D."
        shortEmployeeName(fullName) {
            const words = (fullName || '').trim().split(/\s+/).filter(Boolean)
            if (words.length < 2) return words.join('')
            return words[0] + ' ' + words.slice(1).map(w => w.charAt(0).toLocaleUpperCase('tr-TR') + '.').join('')
        },
        recordTypeText(lawServiceType) {
            // LawServiceType.Name: T = Hizmet, E = Masraf (A pasif)
            const map = { T: this.$t('dailyworkReport.recordTypeService'), E: this.$t('dailyworkReport.recordTypeExpense') }
            return map[lawServiceType.trim()] || lawServiceType
        },
        openDailyworkForm(row) {
            this.$refs.dailyworkForm.showInfo(row.id, row.recordId, row.lawMatterRecordNo, row.shortName)
        },
        changeChecked(id, target) {
            const status = target.checked
            if (status) {
                var agentControl = this.rows.filter(p => p.isSelected == true)
                if (agentControl.length > 0) {
                    var dailyworkControl = this.rows.find(p => p.id == id)
                    if (agentControl.filter(p => p.invoiceClientAccountingId == dailyworkControl.invoiceClientAccountingId).length == 0) {
                        // Checkbox normalde kilitli; bu kontrol yedek olarak kalir
                        this.showAgentToast()
                        target.checked = false;
                        return
                    }
                }
            }
            this.rows = this.rows.map((dailyWork) => {
                if (dailyWork.id === id) {
                    return {
                        ...dailyWork,
                        isSelected: status
                    };
                }
                return dailyWork;
            });
        },
        onSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    clientName: search
                }
                const controller = {
                    name: 'LawClient',
                    actionName: 'GetClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.agentOption = response.data.clientList
                    loading(false)
                })
            }
        },
        setClientId(event) {
            this.clientAccountingId = event.clientAccountingId
        },
        getDailyworkReportList() {
            const requestSeq = ++this.requestSeq
            const controller = {
                name: 'LawDailywork',
                actionName: 'GetLawDailyworkReport'
            }
            const data = {
                employeeId: this.employeeSelect,
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                lawMatterRecordNo: this.recordNo,
                lawBillingStatusId: this.lawBillingStatusSelect,
                invoiceClientAccountingId: this.clientAccountingId,
                recordDateStart: this.recordDateStart,
                recordDateEnd: this.recordDateEnd,
                ownerClient: this.ownerClient,
                description: this.description,
                shortName: this.shortName,
                firstLawyerId: this.firstLawyerSelect,
                lawServiceTypeId: this.recordTypeSelect,
                sortField: this.sortField,
                sortDirection: this.sortDirection
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                // Daha yeni bir istek gonderildiyse bu yanit bayattir, uygulanmaz
                if (requestSeq !== this.requestSeq) { loader.hide(); return }
                if (response.data.resultStatus == true) {
                    this.total = response.data.total
                    this.currencyTotals = response.data.currencyTotals || []
                    this.rows = response.data.lawDailyworkList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })

        },
        showLawMatterForm(row) {
            this.$refs.lawMatterForm.showInfo(row.recordId)
        },
        async showInvoiceForm() {
            var dailyworks = this.rows.filter(i => i.isSelected === true);
            if (dailyworks.length == 0) {
                this.$ErrorSaveAlert()
                return
            }
            // Fatura, form acilirken olusturulup numara aliyor; bu yuzden once onay aliniyor
            const totals = this.selectedTotals.map(t => `${t.currency} ${this.$formatMoneyTr(t.amount)}`).join(' · ')
            const result = await this.$PrivateConfirm(
                this.$t('dailyworkReport.createInvoiceConfirmTitle'),
                this.$t('dailyworkReport.createInvoiceConfirmText', { agent: this.selectedAgent.name, count: dailyworks.length, totals: totals }),
                'warning',
                this.$t('dailyworkReport.createInvoiceConfirmButton'),
                this.$t('alerts.not_delete_button')
            )
            if (!result.value) return
            this.$refs.invoiceForm.showInfoFromDailyWorkList(dailyworks)
        },
        async archiveRecord(row) {
            const result = await this.$ArchiveConfirm();
            if (result.value) {
                const controller = {
                    name: 'LawDailywork',
                    actionName: 'ArchiveDailyWork'
                }
                const data = {
                    id: row.id
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                const response = await this.$store.dispatch('moduleAuth/customService', payload);
                if (response.data.resultStatus == true) {
                    this.$ArchiveAlert()
                    this.getDailyworkReportList()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                    this.getDailyworkReportList()
                }
            }

        },
        isArchiveButonHidden(row) {
            if (row.lawBillingStatusId == 2 && localStorage.getItem('RoleId') == 1)
                return false
            return true
        },
        exportExcel() {
            const controller = {
                name: 'LawDailywork',
                actionName: 'CreateLawDailyworkReportExcel'
            }
            const data = {
                employeeId: this.employeeSelect,
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                lawMatterRecordNo: this.recordNo,
                lawBillingStatusId: this.lawBillingStatusSelect,
                invoiceClientAccountingId: this.clientAccountingId,
                recordDateStart: this.recordDateStart,
                recordDateEnd: this.recordDateEnd,
                ownerClient: this.ownerClient,
                description: this.description,
                shortName: this.shortName,
                firstLawyerId: this.firstLawyerSelect,
                lawServiceTypeId: this.recordTypeSelect
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(this.$t('Dailywork Report'), response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
    }

}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.dw-record-type {
    display: inline-block;
    background: #F3F4F6;
    color: #374151;
    padding: 2px 7px;
    border-radius: 4px;
    white-space: nowrap;
}

// Genislikler Word'deki px degerleri; em ile oranlamak tabloyu ekrandan tasiriyor.
// Sahip ve Kisa Ad'in asgari genisligi kelimelerin harf ortasindan bolunmesini onler.
.dw-agent-cell {
    min-width: 190px;
}

.dw-owner-cell {
    min-width: 6em;
    max-width: 150px;
}

.dw-short-name-cell {
    min-width: 6em;
    max-width: 140px;
}

.dw-description-cell {
    min-width: 320px;
}

// Word 13px/12px oranini tablonun yazi boyutuna gore uygular
.dw-agent-name {
    color: #1F2937;
}

.dw-agent-no {
    font-size: 0.92em;
    color: #6B7280;
}

.dw-filter-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr)) auto;
    column-gap: 28px;
    row-gap: 0.25rem;
}

.dw-filter-row2-start {
    grid-column-start: 1;
}

.dw-filter-actions {
    grid-row: 2;
    grid-column: 7;
    align-self: end;
    // Tarih kutulari (32px) secim kutularindan (30px) yuksek; butonlar kutularin ortasina gelsin
    padding-bottom: 2px;
    display: flex;
    justify-content: flex-end;
}

@media (max-width: 991.98px) {
    .dw-filter-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .dw-filter-row2-start {
        grid-column-start: auto;
    }

    .dw-filter-actions {
        grid-row: auto;
        grid-column: 1 / -1;
        margin-top: 0.5rem;
    }
}

.dw-selection-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 9px 14px;
    background: #FFF7ED;
    border: 1px solid #FED7AA;
    border-radius: 6px;
    color: #1F2937;
}

.dw-selection-clear {
    color: #C2410C !important;
    text-decoration: none;
    cursor: pointer;
}

.dw-selection-clear:hover {
    text-decoration: underline;
}

.dw-invoice-btn.btn:disabled {
    background-color: transparent !important;
    border-color: #D1D5DB !important;
    color: #9CA3AF !important;
    opacity: 1;
    cursor: not-allowed;
    pointer-events: auto;
}

.dw-invoice-btn.dw-invoice-btn-active,
.dw-invoice-btn.dw-invoice-btn-active:hover,
.dw-invoice-btn.dw-invoice-btn-active:focus {
    background-color: var(--primary) !important;
    border-color: var(--primary) !important;
    color: #1F2937 !important;
    font-weight: 700;
}

// Bazi basliklar iki satira kiriliyor; temanin siralama oklari hucrenin dikey ortasinda, metin de ortada olsun
#dailyworkReportTable thead th {
    vertical-align: middle;
}

.dw-table-wrap {
    position: relative;
}

// vgt bu alt bolumu kenarlikli bir kutuya aliyor; ozet tablodan bagimsiz dursun
#dailyworkReportTable .vgt-wrap__actions-footer {
    border: 0;
}

.dw-currency-summary {
    width: auto;
    min-width: 400px;
    // Ana tablonun yazi olcegi (vgt tablo yazisi govdeden 1.15 kat buyuk)
    font-size: 1.15em;
    margin-top: 1rem;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
    font-variant-numeric: tabular-nums;

    th,
    td {
        padding: 0.5rem 1rem;
        border-bottom: 1px solid #E5E7EB;
        white-space: nowrap;
    }

    th {
        background: #F3F4F6;
        color: #374151;
        font-weight: 700;
    }

    tbody tr:last-child td {
        border-bottom: 0;
    }
}

.dw-agent-toast {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    display: flex;
    align-items: flex-start;
    padding: 14px;
    background: #fff;
    border-radius: 0.428rem;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    white-space: nowrap;
}

.dw-agent-toast-icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 1.8rem;
    height: 1.8rem;
    margin-right: 0.75rem;
    border-radius: 50%;
    background: #B45309;
    color: #fff;
    font-weight: 700;
}

.dw-agent-toast-title {
    color: #B45309;
    line-height: 26px;
}

.dw-agent-toast-close {
    margin-left: 1rem;
    line-height: 26px;
}

.dw-ring {
    display: inline-block;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    border: 1.5px solid;
    margin-top: 4px;
}

.dw-ring-green {
    border-color: #16A34A;
}

.dw-ring-yellow {
    border-color: #F5A524;
}

.dw-ring-red {
    border-color: #DC2626;
}

.dw-cb-disabled,
.dw-cb-disabled .custom-control-label {
    cursor: not-allowed;
}

.dw-cb-disabled .custom-checkbox .custom-control-input:disabled:not(:checked) ~ .custom-control-label::before {
    background-color: #F3F4F6;
    border-color: #E5E7EB;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
